<script>
    import { isDarkTheme } from '../../../store.js';
    export let labels;

    const getTechName = (path) => {
        if (path.leth <= 0) {
            return 'technology logo';
        }
        const name = path.length - 4;
        path = path.slice(0, name);
        path = path.split('\\').pop().split('/').pop();
        return path.charAt(0).toUpperCase() + path.slice(1);
    }
    const getLabel = (imgName) => {
        let name = imgName.length - 4;
        name = imgName.slice(0, name);
        return name;
    }
</script>

<div class="p-absolute d-flex labels_cnt">
    <div class="d-flex labels_cnt__inner" >
        {#each labels as label, index}
            <span class="tooltip technology_label technology_label_{ index }" data-tooltip="{ getTechName(label) }">
                <img src="/images/technology/{ getLabel(label) }.svg" alt="{ getTechName(label) }" class:inactive_icon={ $isDarkTheme }>
                <img src="/images/technology/{ getLabel(label) }_white.svg" alt="{ getTechName(label) }" class:inactive_icon={ !$isDarkTheme }>
            </span> 
        {/each}
    </div>         
</div>

<style lang="scss">
    .labels_cnt{
        height: 100%;
        margin-left: 2%;
        margin-right: 2%;
        left: 0;
        right: 0;
        top: 0;
        bottom: 0;
        align-items: stretch;
        z-index: 60;
        &__inner{
            display: flex;
            align-items: flex-end;
            margin-left: -0.2rem;
            margin-right: -0.2rem;
            padding-bottom: 4.5%;
            width: 100%;
            > span{
                width: (100% / 8);
                padding: 0 0.2rem;
                display: block;
            }
        }
    }
    img{
        width: 100%;    
        height: auto;
        display: block; 
        transition: opacity 0.45s cubic-bezier(0.445, 0.050, 0.550, 0.950);
    }
    .inactive_icon{
        visibility: hidden;
        opacity: 0;
        pointer-events: none;
        position: absolute;
        z-index: 0;
    }
    @for $i from 0 through 9 {
        .technology_label_#{$i}{
            margin-bottom: ($i * 0.7%);
        }
    }
</style>